import { Box, Avatar } from "@mui/material";
import { useAuth } from "../../auth/context";
import _ from "lodash";

export default function AvatarUser() {
  const { user } = useAuth();
  const bgColor = "linear-gradient(90deg, #86B1D0 0%, #3887BE 50%, #2E5F81 100%)";

  return (
    <Box sx={{ background: bgColor, width: 32, height: 32, borderRadius: "50%", p: "1px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>
      <Avatar sx={{ backgroundColor: "white", color: "primary.main", width: 30, height: 30, fontSize: 16 }}>{`${_.first(user.name)}${_.first(user.surname)}`}</Avatar>
    </Box>
  );
}
